import React from "react";
import ServiceHero from "../../components/ServiceHero";

const WebsiteDevelopmentHome = () => (
  <ServiceHero
    eyebrow="Website Development"
    title="Websites engineered to"
    highlight="move business forward."
    description="We build fast, scalable websites that turn attention into action and give your business a stronger foundation for growth."
    features={[
      "Conversion-focused experiences",
      "Responsive across every screen",
    ]}
    image="/Images/webh.webp"
    imageAlt="Responsive website displayed across desktop, tablet, and mobile devices"
    visualLabel="Web experiences that perform"
    visualTitle="From first click to lasting customer relationship."
    fitViewport
  />
);

export default WebsiteDevelopmentHome;
